import seoConfig from './seo.json';

// Bài hỏi đáp (bảng posts) nằm ở /hoi-dap/<slug>, chung khu với bài hướng dẫn tĩnh public/hoi-dap/*.html.
// Bài có trong seo.json "qaPosts" dùng slug đặt tay (giữ nguyên khi sửa tiêu đề, /qa/posts/<id> chuyển 301 sang đây).
// Bài mới chưa khai báo dùng slug tự sinh từ tiêu đề, id ở cuối: /hoi-dap/<tieu-de>-<id>.
// scripts/generate-seo.js dùng cùng quy tắc (slugify, qaPostPath) khi prerender và sinh _redirects.
const QA_POSTS = seoConfig.qaPosts || [];

export const slugify = (text) => String(text || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/đ/g, 'd')
  .replace(/Đ/g, 'D')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '')
  .slice(0, 80)
  .replace(/-+$/, '');

// Không biết tiêu đề (vd. thông báo chỉ có post_id) thì dùng /hoi-dap/bai-<id>, trang chi tiết tự đổi sang URL chuẩn
export const qaPostPath = (id, title) => {
  const mapped = QA_POSTS.find((post) => String(post.id) === String(id));
  if (mapped) return `/hoi-dap/${mapped.slug}`;
  const base = slugify(title) || 'bai';
  return `/hoi-dap/${base}-${id}`;
};

// Title/description đặt tay trong seo.json "qaPosts" (title không kèm "| CaskBack"), {} nếu không có
export const qaPostSeo = (id) => QA_POSTS.find((post) => String(post.id) === String(id)) || {};

const countWords = (html) => String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ')
  .split(/\s+/).filter(Boolean).length;

// Bài quá ngắn (dưới seo.json "qaMinWords" từ) thì noindex và không vào sitemap; "noindex" trong qaPosts ghi đè.
// scripts/generate-seo.js dùng cùng quy tắc, nên React không ghi đè robots của bản prerender
export const qaPostNoindex = (id, post) => {
  const { noindex } = qaPostSeo(id);
  if (typeof noindex === 'boolean') return noindex;
  return countWords(post.summary) + countWords(post.content) < (seoConfig.qaMinWords || 0);
};

// Slug trong /hoi-dap/<slug> -> id bài hỏi đáp, null nếu không phải bài hỏi đáp
export const qaPostIdFromSlug = (slug) => {
  const mapped = QA_POSTS.find((post) => post.slug === slug);
  if (mapped) return String(mapped.id);
  const match = /-(\d+)$/.exec(slug || '');
  return match ? match[1] : null;
};
